import { Fragment } from "react";
import { Box, Typography } from "@mui/material";
import styles from "../ContractSearch.styles";
import { parseAnswer } from "../ContractSearchHelper";

interface AnswerMarkdownProps {
  answer: string;
}

/**
 * Renders the AI's light-Markdown answer: paragraphs, `**bold**` runs and one
 * bold heading per contract. Everything is emitted as React text nodes, so
 * nothing in the answer can ever be interpreted as HTML.
 */
const AnswerMarkdown = ({ answer }: AnswerMarkdownProps) => {
  const blocks = parseAnswer(answer);
  if (!blocks.length) return null;

  return (
    <Box sx={styles.answerBlocks}>
      {blocks.map((block, index) =>
        block.kind === "heading" ? (
          <Typography component="h4" key={index} sx={styles.answerHeading}>
            {block.runs.map((run) => run.text).join("")}
          </Typography>
        ) : (
          <Typography component="p" key={index} sx={styles.answerBody}>
            {block.runs.map((run, runIndex) => (
              <Fragment key={runIndex}>
                {run.bold ? <strong>{run.text}</strong> : run.text}
              </Fragment>
            ))}
          </Typography>
        ),
      )}
    </Box>
  );
};

export default AnswerMarkdown;
